import Device, {DeviceData} from "@/types/clients/esquire/data/domotics/device";
import _ from "lodash";

export interface IUnitData {
  id: string;
  unit_type_id: string;
  single_bed_count: number;
  double_bed_count: number;
  domotics_devices: DeviceData[];
}

export default class Unit {
  public id: string;
  public unitTypeId: string;
  public singleBedCount: number;
  public doubleBedCount: number;
  public domoticsDevices: Device[];

  constructor(data: IUnitData) {
    this.id = data.id;
    this.unitTypeId = data.unit_type_id;
    this.singleBedCount = data.single_bed_count;
    this.doubleBedCount = data.double_bed_count;
    this.domoticsDevices = _.map(data.domotics_devices, (data: DeviceData) => new Device(data));

  }

  toDTO(): IUnitData {
    return {
      id: this.id,
      unit_type_id: this.unitTypeId,
      single_bed_count: this.singleBedCount,
      double_bed_count: this.doubleBedCount,
      domotics_devices: this.domoticsDevices.map(dev => dev.toDTO())
    };

  }
  static fromDTO(dto: IUnitData): Unit {
    return new Unit(dto);
  }

}
